<template>
  <v-col md="4" sm="6" xs="12">
    <v-card outlined class="helpcard">
      <v-card-text>
        <h2 class="mb-3">{{ title }}</h2>
        <slot></slot>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  props: ["title"]
};
</script>

<style lang="scss">
@media only screen and (max-width: 414px) {
  .helpcard {
    align-items: flex-start !important;
    padding-top: 5px;
    min-height: 100px !important;
  }
}

@media only screen and (max-width: 1024px) {
  .helpcard {
    align-items: flex-start !important;
    padding-top: 5px;
  }
}

.helpcard {
  /* padding: 30px 10px; */
  -js-display: flex;
  display: flex;
  align-items: center;
  color: #545454;
  min-height: 330px;

  &::after {
    content: "";
    min-height: inherit;
    font-size: 0;
  }

  .card--title {
    color: #484848;
    margin-bottom: 6px;
  }

  p {
    margin-bottom: unset !important;
    color: #707070;
  }

  a {
    text-decoration: none;
  }

  .info--title {
    font-weight: 600;
    color: #484848;
  }
}
</style>
